<template lang="pug">
    .auth-page
        header.serials-page__header
            HeaderBase
            HeaderMenu
        main.auth-page__container
            AuthWrapper
                ul.register__through.uk-flex.uk-flex-between.uk-flex-bottom(data-uk-tab)
                    li(:class="{'uk-active': isPhoneRegister}")
                        a(@click="isPhoneRegister = true") номер телефона
                    li(:class="{'uk-disabled': lockEmailRegister, 'uk-active': !isPhoneRegister}")
                        a(@click="isPhoneRegister = false") Эл. почта
                form(@submit.prevent="nextStep(null)")
                    InputField.register__field(
                        v-if="isPhoneRegister"
                        type="tel"
                        icon="tel"
                        placeholder="Номер телефона"
                        v-model="form.phone"
                        :disabled="buttonDisabled"
                        autocomplete="tel"
                    )
                    InputField.register__field(
                        v-else
                        type="email"
                        icon="mail"
                        placeholder="Электронная почта"
                        v-model="form.email"
                        :disabled="buttonDisabled"
                        autocomplete="email"
                    )
                    Errors.uk-margin-bottom(
                        :errors="errors"
                        v-if="Object.keys(errors).length"
                    )
                    button.register__btn(
                        type="submit"
                        :disabled="buttonDisabled"
                    ) Попробовать бесплатно
                template(#footer)
                    Agreement(type="free")


</template>

<script>
import HeaderBase from "@/components/Header";
import HeaderMenu from "@/components/HeaderMenu";
import AuthWrapper from "@/views/auth/components/AuthWrapper";
import InputField from "@/components/InputField";
import validatePassword from "@/mixins/validatePassword";
import RegisterMixins from "@/mixins/register";
import Errors from "@/components/Errors";
import utils from "@/mixins/utils";
import Agreement from "./components/Agreement";

export default {
  name: "RegisterFree",

  components: {
    AuthWrapper,
    HeaderBase,
    HeaderMenu,
    InputField,
    Errors,
    Agreement
  },
  mixins: [validatePassword, RegisterMixins, utils],
  data: () => ({
    lockEmailRegister: false
  })
};
</script>
